(function(){
    'use strict';
    angular.module('Directives').directive('bbaChart', bbaChart);
    
    bbaChart.$inject = ['$timeout', '$location'];

    function bbaChart($timeout, $location){
        return {
            restrict: 'E',
            templateUrl: '/templates/directives/bbaChart.html',
            replace: true,
            scope: {
                chartData: '=',
                chartId: '='
            },
            link: bbaChartLink
        }
        function bbaChartLink($scope, $element, $attrs){
            $scope.$watch('chartData.data', function(n){
                if(n) {
                    let chart = AmCharts.makeChart($scope.chartId, $scope.chartData.data);
                    setChartHeight($scope.chartData.config, $scope.chartId);
                }
            });
            $scope.goTo = function(){
                let path = $scope.chartData.config.viewPath;
                let params = $scope.chartData.config.searchParams || '';
                $location.path(path).search(params);
            }
        }
        function setChartHeight(config, chartId){
            let widthVal = config.width ? config.width : '100%';
            let heightVal = config.height ? config.height : '100%';
            document.getElementById(chartId).style.width = widthVal;
            document.getElementById(chartId).style.height = heightVal;
        }
    }
})()


// WEBPACK FOOTER //
// ./js/directives/bbaChart.js